import { type Room } from "matrix-js-sdk/src/matrix";
import React, { type JSX } from "react";

import { useUnreadNotifications } from "../../../../hooks/useUnreadNotifications";
import { StatelessNotificationBadge } from "./StatelessNotificationBadge";

interface Props {
    room?: Room;
    threadId?: string;
    /**
     * If true, where we would normally show a badge, we instead show a dot. No numeric count will
     * be displayed.
     */
    forceDot?: boolean;
}

export function UnreadNotificationBadge({ room, threadId, forceDot }: Props): JSX.Element {
    const { symbol, count, level } = useUnreadNotifications(room, threadId);

    return <StatelessNotificationBadge symbol={symbol} count={count} level={level} forceDot={forceDot} />;
}
